import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import { showToast, ToastVariant } from "@repo/ui/toast/toast";
import type { FC } from "react";
import { useDeleteToolMutation } from "../../api/entities/tool.js";

interface DeleteToolModalProps {
  isOpen: boolean;
  onClose: () => void;
  toolId: string;
  toolName: string;
  onToolDeleted: () => void;
}

export const DeleteToolModal: FC<DeleteToolModalProps> = ({
  isOpen,
  onClose,
  toolId,
  toolName,
  onToolDeleted,
}) => {
  const [deleteTool, { isLoading: isDeleting }] = useDeleteToolMutation();

  const handleDeleteTool = async () => {
    try {
      await deleteTool(toolId).unwrap();
      showToast({
        variant: ToastVariant.Success,
        title: "Tool deleted",
        description: `${toolName} has been deleted successfully.`,
      });
      onClose();
      onToolDeleted();
    } catch (error) {
      console.error("Failed to delete tool:", error);
      showToast({
        variant: ToastVariant.Error,
        title: "Failed to delete tool",
        description: "Please try again.",
      });
    }
  };

  return (
    <SimpleModal
      isOpen={isOpen}
      variant={SimpleModalVariant.Warning}
      title="Delete tool"
      subtitle="Are you sure you want to delete this tool? This action cannot be undone."
      confirmButtonText="Delete tool"
      isPrimaryButtonLoading={isDeleting}
      onCancel={onClose}
      onConfirm={handleDeleteTool}
    />
  );
};
